<template>
  <div>
    <el-input :value="value[lang]" @input="handleChangeInput" @blur="handleInputBlur"  v-if="lang" v-bind="$attrs" />
    <nation-list
        ref="nationList"
        class="lang-box"
        @click="handleChangeCurrentLang"
        @onList="debouncedFunction"
        :high-light="lineHeightList"
        v-bind="$attrs"
        :list="list"
        :disabled="disabledNation" />
  </div>
</template>

<script>
import {debounce} from "../../utlis/utlis";
import NationList from "../nation/NationList";
import Vue from "vue";
export default {
  name: "RecipeInput",
  components: {NationList},
  model: {
    event: "input",
    prop: "value"
  },
  props: {
    value: {
      type: Object,
      default: () => {return {}}
    },
    disabledNation: {
      type: Boolean,
      default: false,
    },
    waitTime: {
      type: Number,
      default: 1000,
    },
    list: {
      type: Array,
      default: () => {return []}
    }
  },
  data() {
    return {
      lang: "",
      langs: {},
      lineHeightList: [],
      langList: [],
      debouncedFunction: null
    }
  },
  created() {
    this.debouncedFunction = debounce(this.handleChangeInputModel, this.waitTime, false);
  },
  methods: {
    // 设置数据响应
    handleChangeInputModel(list) {
      this.langList = list;
      // 先移除不存在的语言key;
      Object.keys(this.value).forEach(lang => {
        if (!this.langList.includes(lang)) {
          Vue.delete(this.value, lang);
        }
      })

      list.forEach(lang => {
        let langVal = this.value[lang] || "";
        this.$set(this.value, lang, langVal);
      })
      this.$emit("input", this.value);
    },


    // 切换语言并设置高亮
    handleChangeCurrentLang(e) {
      this.lang = e.value;
      this.handleChangeHighLight();
    },

    // 设置高亮
    handleChangeHighLight() {
      let list = Object.keys(this.value);
      this.lineHeightList = list.filter(i => this.value[i] !== '' && this.value[i]);
    },

    handleInputBlur(e) {
      this.handleChangeHighLight();
      this.$emit("blur", e);
    },

    // 输入值并暴露
    handleChangeInput(val) {
      this.value[this.lang] = val;
      this.$emit('input', this.value);
    },

    handleSetDefault() {
      this.$refs.nationList.handleSetCurrent(0);
    }

  },
  watch: {
    value: {
      handler() {
        let keyLength = Object.keys(this.value).length;
        let langListLength = this.langList.length;

        // 初始化数据
        if(!keyLength && langListLength) {
          this.handleChangeInputModel(this.langList);
          this.lineHeightList = [];
          this.lang = this.langList[0];
          this.$refs.nationList.handleSetCurrent(0);
        }
      },
      immediate: true,
      deep:true,
    },
    /*list: {
      handler(list) {
        console.log('我这是最新的', list);
      },
      immediate: true,
      deep: true,
    }*/
  },

}
</script>

<style scoped>
.lang-box {
  display: flex;
  margin-top: 14px;
}
</style>